import React from 'react';

import { MOA_COLOR } from 'shared/constants/colors';

import { GenericPSA } from './GenericPSA';


// TODO: Probably we don't need anymore..?
// import {
//   setNavbarVisibility,
//   setFooterVisibility,
// } from 'shared/actions/view/web';


const ErrorCrest = ({ code }) => (
  <div
    className='moa-ff-argent f1'
    style={{ color: MOA_COLOR.stories.brinkPink }}
  >
    {code}
  </div>
);


export const GenericError = ({
  code = 'Oops!',
  headline = 'Sorry, something went wrong.',
  subheading = null,
  children,
}) => (
  <GenericPSA
    crest={<ErrorCrest code={code} />}
    headline={headline}
    subheading={subheading}
  >
    {children}
  </GenericPSA>
);



// WEBPACK FOOTER //
// ./src/pages/_system/GenericError.js